// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"741":"a73c6d9b3d0ac59c","2192":"d275b629f381e70d","4067":"228bd38bca229def","8131":"490555aadedcce80"}[chunkId] + ".js";
};